module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/firstStep-a0fb903aaa927a6fd5940f5755260d0c.png";